A privacy policy consent component of a `DraftPositionProfile_ApplicationQuestionnaire`.

This consists of a URL for candidates to view the privacy policy and text to prompt the candidate as to whether or not they agree.

The privacy policy consent component presents the candidate with a 'Yes' or 'No' choice.
